import ChartRepository from '@src/repositories/ChartRepository';

class ChartService {
  constructor() {
    this.chartRepository = new ChartRepository();
  }

  async createChart({ data, orgId, divId = null, boardId }) {
    return this.chartRepository.create({ data, orgId, divId, boardId });
  }

  async updateChart({ data, orgId, divId = null, boardId, chartId }) {
    return this.chartRepository.update({ data, orgId, divId, boardId, chartId });
  }

  async getChart({ orgId, divId = null, boardId, chartId }) {
    return this.chartRepository.get({ orgId, divId, boardId, chartId });
  }
}

export default ChartService;
